'use strict';

import {
  identity,
  isArray,
  noop
} from  './lang';

const V_MODEL = 'vModel';
const V_ON_CHANGE = 'vOn:change';
const DISABLED = 'disabled';
const OPTIONS = 'options';
const OPTION_VALUE = 'optionValue';
const OPTION_TEXT = 'optionText';
const TRANSFORM_VIEW = 'transformView';

function getter(key, object) {
  return object[key];
}

export default {
  params: [
    V_MODEL,
    V_ON_CHANGE,
    DISABLED,
    OPTIONS,
    OPTION_VALUE,
    OPTION_TEXT,
    TRANSFORM_VIEW
  ],
  paramWatchers: {
    [DISABLED]() {
      Vue.nextTick(this.onChangeVm);
    },
    [OPTIONS]() {
      Vue.nextTick(this.onChangeVm);
    }
  },
  bind() {
    // TODO: to update when the option.disabled has been updated
    this.transformViewFn = TRANSFORM_VIEW in this.params
      ? this.params[TRANSFORM_VIEW]
      : Number;
    this.onChangeVm = this.onChangeVm.bind(this);
    this.onChangejQuery = this.onChangejQuery.bind(this);
    this.initAsync = this.initAsync.bind(this);
    Vue.nextTick(this.initAsync);
  },
  unbind() {
    this.$element.off('change', this.onChangejQuery);
    this.$element.chosen('destroy');
    this.unwatchModel();
  },
  initAsync() {
    this.$element = jQuery(this.el);
    this.updateHtml();
    let config = this.vm.$eval(this.expression);
    this.$element.chosen(config);
    this.$element.on('change', this.onChangejQuery);
    this.onChangeCallback = this.getCallback(V_ON_CHANGE);
    this.unwatchModel = V_MODEL in this.params
      ? this.vm.$watch(this.params[V_MODEL], this.onChangeVm)
      : noop;
  },
  onChangejQuery() {
    let value = this.$element.val();
    let isMultiple = this.isMultiple();
    let valueAsArray = isArray(value) ? value : [value];
    let transformedValue = isMultiple ?
                           valueAsArray.map(this.transformViewFn) :
                           this.transformViewFn(value);
    if (V_MODEL in this.params) {
      this.vm.$set(this.params[V_MODEL], transformedValue);
    }
    this.onChangeCallback();
  },
  onChangeVm() {
    this.updateHtml();
    this.$element.trigger('chosen:updated');
  },
  updateHtml() {
    if (!(OPTIONS in this.params)) {
      return;
    }
    let getText = OPTION_TEXT in this.params
      ? getter.bind(this, this.params[OPTION_TEXT])
      : identity;
    let getValue = OPTION_VALUE in this.params
      ? getter.bind(this, this.params[OPTION_VALUE])
      : identity;
    let isMultiple = this.isMultiple();
    let selectedValue = V_MODEL in this.params
      ? this.vm.$get(this.params[V_MODEL])
      //  for single: NaN (because NaN !== NaN), for multiple: []
      : this.getDefaultSelectedValue(isMultiple);
    let array = this.params[OPTIONS];
    let fragment = document.createDocumentFragment();
    // Fix for showing of a placeholder http://stackoverflow.com/a/11649777
    fragment.appendChild(new Option());
    for (let i = 0; i < array.length; i++) {
      let item = array[i];
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLOptionElement/Option
      let text = getText(item);
      let value = getValue(item);
      let isSelectedValue = this.isSelectedValue(isMultiple, selectedValue, value);
      let option = new Option(text, value, isSelectedValue, isSelectedValue);
      fragment.appendChild(option);
    }
    this.$element.empty();
    this.$element.append(fragment);
  },
  getCallback(key) {
    if (!(key in this.params)) {
      return noop;
    }
    let path = this.params[key];
    let pathFn = path.replace(/\(\)$/, '');
    let pathCtx = path.slice(0, path.lastIndexOf('.'));
    let fn = this.vm.$get(pathFn);
    let ctx = this.vm.$get(pathCtx) || this.vm;
    return fn ? fn.bind(ctx) : noop;
  },
  /**
   * @param {Boolean} isMultiple
   * @returns {Array|Number}
   */
  getDefaultSelectedValue(isMultiple) {
    return isMultiple ? [] : NaN;
  },
  /**
   * @param {Boolean} isMultiple
   * @param {Array|String|Number} selectedValue
   * @param {String|Number} anyValue
   * @returns {Boolean}
   */
  isSelectedValue(isMultiple, selectedValue, anyValue) {
    return isMultiple ?
           selectedValue.indexOf(anyValue) !== -1 :
           selectedValue === anyValue;
  },
  /**
   * @returns {Boolean}
   */
  isMultiple() {
    return Boolean(this.$element.attr('multiple'));
  }
};


// WEBPACK FOOTER //
// ./src/js/directive.js